<template>
    <div>
        <ClientUploadDocuments></ClientUploadDocuments>
    </div>
</template>

<script>
import ClientUploadDocuments from "../components/Docs/ClientUploadDocuments";

export default {
    components: {
        ClientUploadDocuments,
    },
    data() {
        return {
            error:null,
        };
    },
    methods: {},
    filters: {},
};
</script>
<style scoped>
.errorAlert{
    background-color:red;
    color:white;
}

.md-ripple > span {
    position: relative;
}
</style>
